<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 用户管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>待办事项</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-cascader placeholder="请选择指派对象"
					:options="options" :show-all-levels="false"
					v-model="query.userInfo" filterable clearable>
				</el-cascader>
				&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择到货状态" value=""></el-option>
					<el-option key="1" label="待办" value="1"></el-option>
					<el-option key="2" label="处理中" value="2"></el-option>
					<el-option key="3" label="已处理" value="3"></el-option>
				</el-select>&nbsp;
				<el-date-picker
						type="datetime"
						placeholder="开始时间"
						v-model="query.createTimeStart"
						value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.createTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="content" label="事项"></el-table-column>
				<el-table-column prop="handlerName" label="指派对象" width="100"></el-table-column>
                <el-table-column prop="expirationTime" label="最晚处理时间" width="160"></el-table-column>
				<el-table-column prop="status" label="状态" width="90">
					<template slot-scope="scope">
						<el-tag :type= "(scope.row.status == 3)?'success':((scope.row.status < 3 && new Date(scope.row.expirationTime).getTime() < new Date().getTime())?'danger':((scope.row.status < 3 && new Date(scope.row.expirationTime).getTime() - new Date().getTime() <  172800000)?'warning':'info'))" >{{statusFormat(null, null, scope.row.status)}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit'] && scope.row.enableDelete && scope.row.status == 1"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
							class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="待办事项" prop="content">
					<el-input type=textarea :rows=5 v-model="form.content"> </el-input>
                </el-form-item>
				<el-form-item label="指派对象" prop="userInfo">
					<el-cascader placeholder="请选择指派对象"
						:options="options" :show-all-levels="false"
						v-model="form.userInfo" filterable clearable>
					</el-cascader>
                </el-form-item>
                <el-form-item label="最晚处理时间" prop="expirationTime">
					<el-date-picker
						type="datetime"
						placeholder="请选择时间"
						v-model="form.expirationTime"
						value-format="yyyy-MM-dd HH:mm:SS"
					></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="50%">
			<el-form ref="show" :model="show" label-width="120px">
				<el-descriptions class="margin-top" title="" :column="1" size="medium" labelStyle="width:180px;" border>
					<el-descriptions-item>
						<template slot="label">
							待办事项
						</template>
						{{show.content}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							最晚处理时间
						</template>
						{{show.expirationTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							当前状态
						</template>
						{{statusFormat(null, null, show.status)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							处理结论
						</template>
						{{show.deal}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							处理时间
						</template>
						{{show.dealTime}}
					</el-descriptions-item><el-descriptions-item>
						<template slot="label">
							创建人
						</template>
						{{show.createTime}}
					</el-descriptions-item>
					</el-descriptions-item><el-descriptions-item>
						<template slot="label">
							创建时间
						</template>
						
					</el-descriptions-item>
				</el-descriptions>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchToDoListDataByCreater, saveToDoList, deleteToDoList, getToDoList, getDepartmentUserTree } from '../../../api/index';

export default {
    name: 'todo-list',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10,
				userInfo:[]
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
			showVisible: false,
            pageTotal: 0,
            form: {},
			show:{},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
                content: [{ required: true, message: '请输入待办事项', trigger: 'blur' }],
				userInfo: [{ required: true, message: '请选择指派对象', trigger: 'blur' }],
				expirationTime: [{ required: true, message: '请选择最晚处理时间', trigger: 'blur' }]
            },
			statusKV:[{"key":1,"value":"待办"},{"key":2,"value":"处理中"},{"key":3,"value":"已处理"}],
			options:[],
			controll:{},
			departmentMapping:{}
        };
    },
    created() {
		this.controll = getControll("todo-list");
		this.getUser();
        this.getData();
    },
    methods: {
		statusFormat(row, column, cellValue) {
			let statusConfig = {"1":"待办", "2":"处理中", "3":"已处理","4":"已撤销"};
			return statusConfig[cellValue];
		},
		getUser() {
			getDepartmentUserTree().then(res => {
				if (res.code == 0 ) {
					this.options = res.data;
					this.getDepartmentMapping(res.data, undefined, undefined);
				} else {
					this.$message.error("获取用户信息失败，" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
			if (this.query.userInfo != undefined) {
				this.$set(this.query, "handler", this.query.userInfo[this.query.userInfo.length - 1]);
			} else {
				this.$set(this.query, "handler", undefined);
			}
            fetchToDoListDataByCreater(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
		getDepartmentMapping(nodes, parent, parentName) {
			for(let i = 0; i < nodes.length; i++) {
				let node = nodes[i];
				let mapping = {};
				let departmentInfo = [];
				let name = "";
				if (parent) {
					departmentInfo = departmentInfo.concat(parent);
					name = parentName;
				}
				departmentInfo.push(node.value);
				name = (name?name + "/":"") + node.label;
				mapping["name"] = name;
				mapping["info"] = departmentInfo;
				this.departmentMapping[node.value+"-"+(node.sign?node.sign:"")] = mapping;
				if (node.children && node.children.length > 0) {
					this.getDepartmentMapping(node.children, departmentInfo, name);
				}
			}
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteToDoList([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteToDoList(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			getToDoList(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
					let mapping = this.departmentMapping[this.form["handler"] + "-1"]; 
					if (mapping) {
						this.$set(this.form, "userInfo", mapping["info"]);
					}
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		//详情操作
		handleShow(index, row) {
			this.idx = index;
			this.show = row;
			this.showVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.form.userInfo != undefined) {
						this.$set(this.form, "handler", this.form.userInfo[this.form.userInfo.length - 1]);
					}
					saveToDoList(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.dealVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
